// extracted by mini-css-extract-plugin
export default {"addFundsModal":"styles_addFundsModal__0YuM8","title":"styles_title__XXXu6","text":"styles_text__KsTWZ","payment-options-container":"styles_payment-options-container__UZi9e"};